export const VideoPlaylist = () => (
    <div className="videoWrapper box-with-shadow">
            <iframe
                width="800"
                height="450"
                src="https://www.youtube.com/embed/videoseries?si=OIKHhwPOw3RNid0_&amp;list=PLSyjT7tGIJNc"
                title="YouTube video player"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                referrerPolicy="strict-origin-when-cross-origin"
                allowFullScreen
            >
            </iframe>
    </div>
);